module.exports = __webpack_public_path__ + "img/pdf.b11be43f.png";